import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {HTH} from "../HTH";
import {gsap} from "gsap"

export class HTHNoWinSymbol extends HTHSymbol {
    private _currentStateSprite: PIXI.Sprite;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NO_WIN) {
        super(symbolData, state);

        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._currentStateSprite.position.set(0, 0);
        this.init(symbolData);

    }

    public getSpineAnimation(symData: ISymbolData): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.addImage();
        this.symbolState = HTHSymbolStates.BLANK;
        return tl;
    }

    public addImage(): void {
        this._currentStateSprite.texture = HTH.assetLoader.getTextures("NoWin/NoWin" + Math.ceil(Math.random() * 3))[0];
        this._currentStateSprite.visible = true;
        this.addChild(this._currentStateSprite);
    }

    public init(symData: ISymbolData): HTHNoWinSymbol {
        this.getSpineAnimation(symData);
        return this;
    }

    public removeAndDestroy(): void {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }
}